import { isUserEntity } from '@backstage/catalog-model';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityLayoutBlueprint } from '@ipen-portal/plugin-common-react';
import { IpenEntityLayout } from '@ipen-portal/plugin-layout-react';

import {
  catalogEntityRouteRef,
  featureFlagsRouteRef,
  infoRouteRef,
  settingsRouteRef,
} from './routes';

export const userPlugin = createFrontendPlugin({
  extensions: [
    PageBlueprint.make({
      name: 'UserSettings',
      params: {
        loader: () =>
          import('./components/UserSettings/UserSettings').then(m => (
            <m.UserSettings />
          )),
        noHeader: true,
        path: '/user',
        routeRef: settingsRouteRef,
      },
    }),

    EntityLayoutBlueprint.make({
      name: 'UserInfo',
      params: {
        filter: isUserEntity,
        loader: async () =>
          import('./components/UserInfo/UserInfo').then(m => () => (
            <IpenEntityLayout title="User Profile">
              <m.UserInfo />
            </IpenEntityLayout>
          )),
        order: 0,
      },
    }),
  ],
  externalRoutes: {
    catalogEntity: catalogEntityRouteRef,
  },
  pluginId: 'user',
  routes: {
    featureFlags: featureFlagsRouteRef,
    info: infoRouteRef,
    settings: settingsRouteRef,
  },
});
